import { UPDATE_TIMER, CREATE_GAMEFACT, DELETE_GAMEFACT, GET_LIVE_DETAILS, INCREMENT_LIVE_TIMER, UPDATE_GAMEFACT, CREATE_NOTATION, DELETE_NOTATION,UPDATE_NOTATION, CREATE_ARTICLE, DELETE_ARTICLE, UPDATE_ARTICLE, INCREMENT_PERIOD, CREATE_PLAYER, UPDATE_COMPOSITION, UPDATE_INFOMATCH, CREATE_SURVEY, UPDATE_SURVEY, DELETE_SURVEY, GET_MATCH_DETAILS, CREATE_QUIZZ, UPDATE_QUIZZ, DELETE_QUIZZ, UPDATE_PLAYER, AUTOSCORE_GAMEFACTS, UPDATE_INFOACTULIVE, CREATE_QUESTIONBOX, DELETE_QUESTIONBOX, UPDATE_QUESTIONBOX } from '../constants/actionTypes.js'

function buildComposition(payload, players){

    let result = payload.map(p => ({...players.find(player => player._id === p._id), position : p.position, numero : p.numero, isCpt : p.isCpt}))

    result = result.filter(p => p._id)

    return result
}

export default (live = {}, action) => {
    switch(action.type){
        case CREATE_PLAYER:
            // Si un live existe, on parcour tous les matchs, 
            if(live && live.matchsDetails)
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch === action.payload.idMatch && action.payload.player.teams.includes(match.homeTeam._id) && !match.homeTeam.players.find(p => p._id === action.payload.player._id)){
                        return {...match, homeTeam : {...match.homeTeam, players : [...match.homeTeam.players, action.payload.player]}}
                    }else if(match.idMatch === action.payload.idMatch && action.payload.player.teams.includes(match.awayTeam._id) && !match.awayTeam.players.find(p => p._id === action.payload.player._id)){
                        return {...match, awayTeam : {...match.awayTeam, players : [...match.awayTeam.players, action.payload.player]}}
                    }else{
                        return match
                    }
                })}

            return live
        case UPDATE_PLAYER:
            // Si un live existe, on parcour tous les matchs, 
            if(live && live.matchsDetails)
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch === action.payload.idMatch && action.payload.player.teams.includes(match.homeTeam._id) && !match.homeTeam.players.find(p => p._id === action.payload.player._id)){
                        return {...match, homeTeam : {...match.homeTeam, players : [...match.homeTeam.players, action.payload.player]}}
                    }else if(match.idMatch === action.payload.idMatch && action.payload.player.teams.includes(match.awayTeam._id) && !match.awayTeam.players.find(p => p._id === action.payload.player._id)){
                        return {...match, awayTeam : {...match.awayTeam, players : [...match.awayTeam.players, action.payload.player]}}
                    }else{
                        return match
                    }
                })}

            return live
        case GET_LIVE_DETAILS:
            return {...action.payload}
        case GET_MATCH_DETAILS: {
            const payloadId = action.payload.idActu || action.payload.idMatch;

            const currentMatchsDetails = live.matchsDetails || [];
            const currentActualitesDetails = live.actualitesDetails || [];

            const hasMatch = currentMatchsDetails.some(match => {
                const matchId = match.idMatch || match.idActu;
                return matchId === payloadId;
            });

            const hasActu = currentActualitesDetails.some(actu => {
                const actuId = actu.idActu || actu.idMatch;
                return actuId === payloadId;
            });

            return {
                ...live,
                matchsDetails: hasMatch
                    ? currentMatchsDetails.map(match => {
                        const matchId = match.idMatch || match.idActu;

                        if (matchId !== payloadId) {
                            return match;
                        }

                        return {
                            ...match,
                            ...action.payload
                        };
                    })
                    : currentMatchsDetails,
                actualitesDetails: hasActu
                    ? currentActualitesDetails.map(actu => {
                        const actuId = actu.idActu || actu.idMatch;

                        if (actuId !== payloadId) {
                            return actu;
                        }

                        return {
                            ...actu,
                            ...action.payload
                        };
                    })
                    : [...currentActualitesDetails, { ...action.payload }]
            };
        }
        case CREATE_GAMEFACT:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else
                    return {...match, gameFacts : [...match.gameFacts, action.payload]}
            })}
        case AUTOSCORE_GAMEFACTS:
            const {deletedGameFacts, createdGameFacts, idMatch} = action.payload
            if(!live.matchsDetails)
                return live

            const matchDetail = live.matchsDetails.find(m => m.idMatch === idMatch)
            let newGameFacts = matchDetail.gameFacts.filter(g => !deletedGameFacts.includes(g._id))
            newGameFacts = newGameFacts.concat(createdGameFacts)

            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== idMatch)
                    return match
                else
                    return {...match, gameFacts : newGameFacts}
            })}
        case UPDATE_GAMEFACT:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else
                    return {...match, gameFacts : match.gameFacts.map(gf => gf._id === action.payload._id ? action.payload : gf)}
            })}
        case DELETE_GAMEFACT:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(!match.gameFacts || !match.gameFacts.find(gf => gf._id === action.payload))
                    return match
                else
                    return {...match, gameFacts : match.gameFacts.filter(gf => gf._id !== action.payload)} 
            })}
        case CREATE_NOTATION:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else
                    return {...match, notations : [...match.notations, action.payload], pagination : match.pagination + 1}
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(actu.idActu !== action.payload.idMatch)
                    return actu
                else
                    return {...actu, notations : [...actu.notations, action.payload], pagination : actu.pagination + 1}
            })}
        case UPDATE_NOTATION:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else
                    return {...match, notations : match.notations.map(gf => gf._id === action.payload._id ? action.payload : gf)}
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(actu.idActu !== action.payload.idMatch)
                    return actu
                else
                    return {...actu, notations : actu.notations.map(gf => gf._id === action.payload._id ? action.payload : gf)}
            })}
        case DELETE_NOTATION:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(!match.notations || !match.notations.find(n => n._id === action.payload))
                    return match
                else
                    return {...match, notations : match.notations.filter(gf => gf._id !== action.payload), pagination : match.pagination - 1} 
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(!actu.notations || !actu.notations.find(n => n._id === action.payload))
                    return actu
                else
                    return {...actu, notations : actu.notations.filter(gf => gf._id !== action.payload), pagination : actu.pagination - 1} 
            })}
            case CREATE_SURVEY:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, surveys : [...match.surveys, action.payload], pagination : match.pagination + 1}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, surveys : [...actu.surveys, action.payload], pagination : actu.pagination + 1}
                })}
            case UPDATE_SURVEY:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, surveys : match.surveys.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, surveys : actu.surveys.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                })}
            case DELETE_SURVEY:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(!match.surveys || !match.surveys.find(n => n._id === action.payload))
                        return match
                    else
                        return {...match, surveys : match.surveys.filter(gf => gf._id !== action.payload), pagination : match.pagination - 1} 
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(!actu.surveys || !actu.surveys.find(n => n._id === action.payload))
                        return actu
                    else
                        return {...actu, surveys : actu.surveys.filter(gf => gf._id !== action.payload), pagination : actu.pagination - 1} 
                })}
            case CREATE_QUIZZ:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, quizzs : [...match.quizzs, action.payload], pagination : match.pagination + 1}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, quizzs : [...actu.quizzs, action.payload], pagination : actu.pagination + 1}
                })}
            case UPDATE_QUIZZ:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, quizzs : match.quizzs.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, quizzs : actu.quizzs.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                })}
            case DELETE_QUIZZ:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(!match.quizzs || !match.quizzs.find(n => n._id === action.payload))
                        return match
                    else
                        return {...match, quizzs : match.quizzs.filter(gf => gf._id !== action.payload), pagination : match.pagination - 1} 
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(!actu.quizzs || !actu.quizzs.find(n => n._id === action.payload))
                        return actu
                    else
                        return {...actu, quizzs : actu.quizzs.filter(gf => gf._id !== action.payload), pagination : actu.pagination - 1} 
                })}
        case CREATE_QUESTIONBOX:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, questionBoxes : [...match.questionBoxes, action.payload], pagination : match.pagination + 1}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, questionBoxes : [...actu.questionBoxes, action.payload], pagination : actu.pagination + 1}
                })}
            case UPDATE_QUESTIONBOX:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else
                        return {...match, questionBoxes : match.questionBoxes.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else
                        return {...actu, questionBoxes : actu.questionBoxes.map(gf => gf._id === action.payload._id ? action.payload : gf)}
                })}
            case DELETE_QUESTIONBOX :
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(!match.questionBoxes || !match.questionBoxes.find(n => n._id === action.payload))
                        return match
                    else
                        return {...match, questionBoxes : match.questionBoxes.filter(gf => gf._id !== action.payload), pagination : match.pagination - 1} 
                }), actualitesDetails : live.actualitesDetails.map(actu => {
                    if(!actu.questionBoxes || !actu.questionBoxes.find(n => n._id === action.payload))
                        return actu
                    else
                        return {...actu, questionBoxes : actu.questionBoxes.filter(gf => gf._id !== action.payload), pagination : actu.pagination - 1} 
                })}
        case CREATE_ARTICLE:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else{
                    return {...match, articles : [...match.articles, action.payload], pagination : match.pagination + 1}
                }  
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(actu.idActu !== action.payload.idMatch)
                    return actu
                else
                    return {...actu, articles : [...actu.articles, action.payload], pagination : actu.pagination + 1}
            })}
        case UPDATE_ARTICLE:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(match.idMatch !== action.payload.idMatch)
                    return match
                else
                    return {...match, articles : match.articles.map(gf => gf._id === action.payload._id ? action.payload : gf)}
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(actu.idActu !== action.payload.idMatch)
                    return actu
                else
                    return {...actu, articles : actu.articles.map(gf => gf._id === action.payload._id ? action.payload : gf)}
            })}
        case DELETE_ARTICLE:
            if(!live.matchsDetails)
                return live
            return {...live, matchsDetails : live.matchsDetails.map(match => {
                if(!match.articles || !match.articles.find(a => a._id === action.payload))
                    return match
                else
                    return {...match, articles : match.articles.filter(gf => gf._id !== action.payload), pagination : match.pagination - 1} 
            }), actualitesDetails : live.actualitesDetails.map(actu => {
                if(!actu.articles || !actu.articles.find(a => a._id === action.payload))
                    return actu
                else
                    return {...actu, articles : actu.articles.filter(gf => gf._id !== action.payload), pagination : actu.pagination - 1} 
            })}
            case UPDATE_TIMER:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else{
                        return {...match, ...action.payload}
                    }
                        
                })}
            case UPDATE_COMPOSITION:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else{
                        // On doit construire homeHolers, homeSub, awayHolder, awaySub à l'aide du payload et des players de chaque team
                        // payload : homeHolders = [{_id, position, numero}]
                        // players : players = [{tout ce qu'on veut sauf position et numero}]
                        return {...match, ...action.payload, 
                            homeHolders : buildComposition(action.payload.homeHolders, match.homeTeam.players), 
                            awayHolders : buildComposition(action.payload.awayHolders, match.awayTeam.players),
                            homeSubstitutes : buildComposition(action.payload.homeSubstitutes, match.homeTeam.players), 
                            awaySubstitutes : buildComposition(action.payload.awaySubstitutes, match.awayTeam.players)
                        }
                    }
                })}
            case UPDATE_INFOMATCH:
                if(!live.matchsDetails)
                    return live
                return {...live, matchsDetails : live.matchsDetails.map(match => {
                    if(match.idMatch !== action.payload.idMatch)
                        return match
                    else{
                        // On doit construire homeHolers, homeSub, awayHolder, awaySub à l'aide du payload et des players de chaque team
                        // payload : homeHolders = [{_id, position, numero}]
                        // players : players = [{tout ce qu'on veut sauf position et numero}]
                        return {...match, 
                            ...action.payload,
                        }
                    }
                })}
            case UPDATE_INFOACTULIVE:
                if(!live.actualitesDetails)
                    return live
                return {...live, actualitesDetails : live.actualitesDetails.map(actu => {
                    if(actu.idActu !== action.payload.idMatch)
                        return actu
                    else{
                        return {...actu, 
                            ...action.payload,
                        }
                    }
                })}
        default :
            return live
    }
}